import { getRgObjectsOfType as i, RgChildren as r, RG_TYPE as t } from "@project-rouge/rg-core";
import { isBaseBuildObject as l } from "../../queries/index2.js";
import { isSingleDoor as n } from "../../queries/index8.js";
const f = (e) => {
  const o = i(e, r.Building);
  return i(o.filter(l), t.Door).filter(n).length;
};
export {
  f as getBaseBuildSingleDoorsCount
};
//# sourceMappingURL=index8.js.map
